module.exports = __webpack_public_path__ + "img/komunikaty.2e6ff5f5.svg";